import { get } from "@insite/client-framework/Services/ApiService";

interface Params {
    apiRoute: string,
    serialNumber: string
}

export async function loadSelectSourceData(parameter: Params) {
    try {
        // eslint-disable-next-line no-constant-condition
        const { apiRoute, serialNumber } = parameter;
        const response: string = await get(`/api/v2/vendor/${apiRoute}/${serialNumber}`);
        return JSON.parse(response);
    } catch (error) {
        return "Error"
    }

}